
<button class="btn-icon grey-to-blue formula" @click.self="$emit('click', $event)" :disabled="disabled">
  <icon class="florin"></icon>
  <span class="sr-only">Formula Button</span>
</button>
